import type { Brand } from "@borealis/layout-express";
import type { CurrencyCode } from "@borealis/number-format";

export const Currency: Record<Brand, CurrencyCode> = {
  bilbasen: "DKK",
  blocket: "SEK",
  BLOCKET: "SEK",
  dba: "DKK",
  DBA: "DKK",
  finn: "NOK",
  FINN: "NOK",
  tori: "EUR",
  TORI: "EUR",
  vend: "EUR",
};
